import Layout from '@/layout'

const miniProgramRouter = {
  path: '/shoph5',
  component: Layout,
  children: [
    {
      path: '/shoph5_home',
      name: 'shoph5_home',
      meta: {
        title: '首页',
      },
      component: () => import('@/views/shoph5/home.vue'),
    },
    {
      path: '/good/detail/:id',
      name: 'goodDetail',
      meta: {
        title: '商品详情',
      },
      component: () => import('@/views/shoph5/goods/detail.vue'),
    },
    {
      path: '/shop/detail/:storeId',
      name: 'shopDetail',
      meta: {
        title: '店铺详情',
      },
      component: () => import('@/views/shoph5/shop/detail.vue'),
    },

    {
      path: '/orderList/:storeId',
      name: 'wxOrderList',
      meta: {
        title: '订单列表',
      },
      component: () => import('@/views/shoph5/orderList/index.vue'),
    },
    {
      path: '/cart',
      name: 'shopCart',
      meta: {
        title: '购物车',
      },
      component: () => import('@/views/shoph5/cart/index.vue'),
    },
    {
      path: '/settle',
      name: 'shopSettle',
      meta: {
        title: '结算',
      },
      component: () => import('@/views/shoph5/settle/index.vue'),
    },
    {
      path: '/orderDetail',
      name: 'wxOrderDetail',
      meta: {
        title: '订单详情',
      },
      component: () => import('@/views/shoph5/orderList/detail.vue'),
    },
    // 财务支付订单
    {
      path: '/paymentOrder/:storeId',
      name: 'wxPaymentOrder',
      meta: {
        title: '订单列表',
      },
      component: () => import('@/views/shoph5/orderList/paymentOrder.vue'),
    },
  ],
}

export default miniProgramRouter
